/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hoursMinutes: NonNullable<unknown> }} Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs */

const en_admin_external_booking_edit_extra_quantity_minute = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hoursMinutes}h`)
};

const de_admin_external_booking_edit_extra_quantity_minute = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hoursMinutes}h`)
};

const es_admin_external_booking_edit_extra_quantity_minute = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hoursMinutes}h`)
};

const fr_admin_external_booking_edit_extra_quantity_minute = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hoursMinutes}h`)
};

const nl_admin_external_booking_edit_extra_quantity_minute = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hoursMinutes}u`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_quantity_minute = en_admin_external_booking_edit_extra_quantity_minute;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_quantity_minute = en_admin_external_booking_edit_extra_quantity_minute;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_quantity_minute = en_admin_external_booking_edit_extra_quantity_minute;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_quantity_minute = en_admin_external_booking_edit_extra_quantity_minute;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_quantity_minute = en_admin_external_booking_edit_extra_quantity_minute;

/**
* | output |
* | --- |
* | "{hoursMinutes}h" |
*
* @param {Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_quantity_minute = /** @type {((inputs: Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Quantity_MinuteInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_quantity_minute(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_quantity_minute(inputs)
	return ro_admin_external_booking_edit_extra_quantity_minute(inputs)
});
export { admin_external_booking_edit_extra_quantity_minute as "admin.external_booking_edit.extra_quantity_minute" }